import styled, { css } from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const Button = styled.div<{
  isEnabled: boolean;
  isActive: boolean;
  bigSize: boolean;
  borderColor: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  margin-bottom: 12px;

  width: 350px;
  height: ${({ bigSize }) => (bigSize ? "60px" : "40px")};

  background: ${({ isActive }) =>
    isActive ? GrayColors["G-0"] : "rgba(255, 255, 255, 0.6)"};
  border-radius: 8px;
  box-sizing: border-box;
  user-select: none;

  border: ${({ isActive, borderColor }) =>
    isActive ? `2px solid ${borderColor}` : "1px solid transparent"};

  transition: border-color 200ms ease;

  cursor: ${({ isEnabled }) => (isEnabled ? "pointer" : "default")};

  &:hover {
    ${({ isEnabled, isActive, borderColor }) => {
      if (isEnabled && !isActive) {
        return css`
          border-color: ${borderColor};
        `;
      }
    }}
  }
`;

export const Content = styled.div<{
  isEnabled: boolean;
}>`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8em;
  color: ${({ isEnabled }) =>
    isEnabled ? TextColorNames.primary : TextColorNames.secondary};
`;

export const WarningIcon = styled.div`
  position: absolute;
  right: -25px;
`;
